// extracted by mini-css-extract-plugin
module.exports = {"blurry-container":"MakeItBlurry_blurry-container__2mmSi","backdrop":"MakeItBlurry_backdrop__20ALg","message":"MakeItBlurry_message__8HfTp"};